import React from "react";

const Accordion = () => {
  return (
    <div>
      <div id="accordion" className="services-accordion home">
        <div className="card">
          <div className="card-header title-text" id="heading-1">
            <p className="mb-0">
              Great gardens are based on sound garden design principles. We
              believe garden design is about understanding the corresponding
              relationships between spaces, shapes, materials and colour. We
              feel this approach produces a more considered and timeless garden.
            </p>
          </div>
          <div
            id="collapse-1"
            className="collapse"
            aria-labelledby="heading-1"
            data-parent="#accordion"
          >
            <div className="card-body">
              <p>
                As each garden has its own characteristics to work with we meet
                onsite to gain an understanding of your requirements specific to
                the site and in conjunction with a short questionnaire we
                develop a brief for your garden area.
              </p>
              <p>
                Conceptual ideas for the space are discussed along with ideas on
                material selection. Inspirations from our extensive portfolio of
                work are discussed and we explore how they can be applied to
                your home.
              </p>
              <p>
                Following the site consultation a proposal for the following
                services will be forwarded for your consideration.
              </p>
              <p>
                Alternatively you can call or email us on the details below.
                <br />
                (02) 9380 7957 <br />
                imagine@thinkoutsidegardens.com.au
              </p>
            </div>
          </div>
          <button
            className="link-more"
            data-toggle="collapse"
            data-target="#collapse-1"
            aria-expanded="true"
            aria-controls="collapse-1"
          >
            Read More
          </button>
        </div>
      </div>
    </div>
  );
};

export default Accordion;
